import { render, staticRenderFns } from "./productsEdit.vue?vue&type=template&id=27ba89cb&scoped=true&"
import script from "./productsEdit.vue?vue&type=script&lang=js&"
export * from "./productsEdit.vue?vue&type=script&lang=js&"
import style0 from "./productsEdit.vue?vue&type=style&index=0&id=27ba89cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba89cb",
  null
  
)

export default component.exports